export const MAX_FILES = 5
export const MAX_FILE_SIZE = 10 * 1024 * 1024
export const ACCEPTED_FILE_EXTENSIONS = [
  '.png',
  'image/png',
  '.jpg',
  'image/jpg',
  '.jpeg',
  'image/jpeg',
  '.heic',
  'image/heic',
  '.heif',
  'image/heif',
]
